import thumbnailImage from './Thumbnail.svg';
import playlistImage from './Playlist.svg';

const staticImages = {
  thumbnailImage,
  playlistImage,
};

export default staticImages;
